<template>
  <car-detail :car-detail="detailData" :show-price="true" :operate-info="checkEvaluate" @on-go="checkComplete"></car-detail>
</template>
<script>
import CarDetail from '../components/CarDetail'

export default {
  components: { CarDetail },
  data() {
    return {
      id: '',
      checkEvaluate: {
        show: true,
        title: '完整车况>'
      },
      detailData: {
        source: {},
        submitter: {}
      }
    }
  },
  created() {
    let id = this.$route.params.id
    this.$rest.usedCar.getTicket(null, id).then(res => {
      if (res.code === 0) {
        this.detailData = res.data
      } else {
        this.showToast(res.message)
      }
    })
  },
  methods: {
    checkComplete() {
      this.$router.push({
        path: `/usedcar/evaluateReport/${this.detailData.car_info_id}/inquiry`, query: { default: 1 }
      })
    }
  }
}

</script>
<style lang="less">

</style>
